import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var BuzzerState;
(function (BuzzerState) {
    BuzzerState[BuzzerState["OFF"] = 0] = "OFF";
    BuzzerState[BuzzerState["ON"] = 1] = "ON";
})(BuzzerState || (BuzzerState = {}));
export var Buzzer;
(function (Buzzer) {
    let Flags;
    (function (Flags) {
        Flags[Flags["ON_GUARD_STATE_CHANGED"] = 1] = "ON_GUARD_STATE_CHANGED";
    })(Flags = Buzzer.Flags || (Buzzer.Flags = {}));
    Buzzer.get = createAccessors(arrayGetSet('buzzers'), {
        name: 'Сирена',
        physical_output: -1,
        work_time: 0,
        setting_register: 0,
    });
})(Buzzer || (Buzzer = {}));
